import PropTypes from 'prop-types';
import {
  DrawerContent,
  DrawerHeaderLabel,
  DrawerlabelContainer,
  DrawerWrapper
} from "../Drawer/DrawerStyled";
import { BackButton } from "../../pages/MatterDetails/MatterDetailsStyled";
import { X } from "@phosphor-icons/react";
import { Timeline, Drawer } from "antd";
import flagFrame from "../../assets/images/Check.svg";
import  ReWork from "../../assets/images/Reload.svg";
import Success from "../../assets/images/Approved.svg"
import dayjs from 'dayjs';
import { DrawerHeadingUnderlined, RowTyped, DrawerTyped, DrawerUser, DrawerDescription, DrawerTimeline } from "./ReviewNotesStyled";
import { fetchReviewNotes } from '../../slice/MatterDetailsSlice';
import { useDispatch } from "react-redux";
import { useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
const GlobalDrawerStyles = createGlobalStyle`
  .custom-drawer-lower-component .ant-drawer-content-wrapper {
    /* Your override */
    top: 13vh !important;
    font-family: 'Manrope', sans-serif;
    font-size: 13px;
  }
`;
const ReviewNotesModal = ({
  openReviewNotesModal,
  setOpenReviewNotesModal,
  selectedDoc
}) => {
  const dispatch = useDispatch();
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const transformData = (data) => {
    return data.map(note => {
      let icon, type;
      if (note.action_type === "Rework Request") {
        icon = <img alt='rework' src={ReWork} width={30} height={30} style={{ color: "#EB2F96" }} />;
        type = "Rework Requested";
      } else if (note.action_type === "Review Request") {
        icon = <img alt='review' src={flagFrame} width={30} height={30} style={{ color: "#722ED1" }} />;
        type = "Review Requested";
      } else if (note.action_type === "Exchange Completed") {
        icon = <img alt='completed' src={Success} width={30} height={30} style={{ color: "#722ED1" }} />;
        type = "Exchange Completed";
      } else if (note.action_type === "Outcome Dismissed") {
        icon = <img alt='dismissed' src={ReWork} width={30} height={30} style={{ color: "#EB2F96" }} />;
        type = "Outcome Dismissed";
      } else if (note.action_type === "Review Cancelled") {
        icon = <img alt='cancelled' src={ReWork} width={30} height={30} style={{ color: "#EB2F96" }} />;
        type = "Review Cancelled";
      } else {
        icon = <img alt='success' src={Success} width={30} height={30} style={{ color: "#722ED1" }} />
        type = "Approved";
      }
      return {
        type,
        user: note.user_id === Number(localStorage.getItem("user_id")) ? "You" : note.reviewer_name,
        message: note.comment_text,
        time: dayjs(note.created_at).format("MMM D, h:mm A"),
        icon
      };
    });
  };

  useEffect(() => {
    if (openReviewNotesModal) {
      dispatch(fetchReviewNotes(selectedDoc?.unique_id?.substring(1))).then(
        (response) => {
          if (response.error) {
            console.error("Failed to fetch review notes:", response.error);
          } else {
            const sortedReviewNotes = response.payload.data.review_notes.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at)
            );
            setTimelineData(transformData(sortedReviewNotes));
            setLoading(false);
          }
        }
      );
    }
  }, [openReviewNotesModal, dispatch, selectedDoc?.unique_id]);

  const onClose = () => {
    setOpenReviewNotesModal(false);
    setLoading(true);
    setTimelineData([]);
  };

  return (
    <DrawerWrapper>
      <GlobalDrawerStyles />
      <Drawer
        closable={false}
        key="right"
        placement="right"
        onClose={onClose}
        open={openReviewNotesModal}
        width={410}
        loading={loading}
        rootClassName="custom-drawer-lower-component"
      >
        <DrawerContent>
          <DrawerHeadingUnderlined>
            <DrawerlabelContainer>
              <DrawerHeaderLabel>Review Notes</DrawerHeaderLabel>
              <BackButton>
                <X size={20} onClick={onClose} />
              </BackButton>
            </DrawerlabelContainer>
          </DrawerHeadingUnderlined>
          <div style={{ margin: "8% 0" }}>
            <Timeline mode="left">
              {timelineData.map((item, index) => (
                <Timeline.Item
                  key={index + "" + item.type}
                  dot={item.icon}
                  color="gray"
                >
                  <RowTyped>
                    <DrawerTyped>{item.type}</DrawerTyped>
                    <DrawerUser>{item.user}</DrawerUser>
                  </RowTyped>
                  <DrawerDescription>{item.message}</DrawerDescription>
                  <DrawerTimeline>{item.time}</DrawerTimeline>
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        </DrawerContent>
      </Drawer>
    </DrawerWrapper>

  );
}

ReviewNotesModal.propTypes = {
  openReviewNotesModal: PropTypes.bool.isRequired,
  setOpenReviewNotesModal: PropTypes.func.isRequired,
  selectedDoc: PropTypes.object.isRequired
};

export default ReviewNotesModal;